export const pageContainerSx = {
  maxWidth: '1100px',
  margin: '0 auto',
  paddingBottom: '16px',
};

export const mainSx = { paddingTop: '48px' };
